import { mapGetters } from 'vuex'
import mqtt, { mqttSub, mqttUnsub } from 'utils/mqtt'
import isSameStock from 'utils/isSameStock'

export default {
  name: 'askBidPricesPollMixin',
  computed: {
    ...mapGetters([
      'hasHkLv2Permission',
      'hkMarketOpen',
      'usMarketOpen',
      'usHourTrading',
      'mqttConnected'
    ]),
    isNeedPolling() {
      // usHourTrading盘前盘后
      const hkMarketOpenWithPermission =
        this.hkMarketOpen && this.hasHkLv2Permission
      return (
        this.usMarketOpen || this.usHourTrading || hkMarketOpenWithPermission
      )
    },
    pollingSymbol() {
      return this.stock.symbol
    }
  },
  data() {
    return {
      timer: null
    }
  },
  methods: {
    unsubAskBid(symbol = this.pollingSymbol) {
      mqttUnsub('quoteTrade', {
        name: 'quote',
        symbol: symbol,
        type: 'trade'
      })
    },
    subAskBid(symbol = this.pollingSymbol) {
      if (this.isOPT || this.isHK) return
      mqttSub('quoteTrade', {
        name: 'quote',
        symbol: symbol,
        type: 'trade'
      })
    },
    updateAskBid({ data, topic }) {
      const type = topic.split('/').pop()
      if (this.isOPT || this.isHK) return
      // 处理特定的消息
      if (type === 'trade' && isSameStock(data, this.stock)) {
        this.getUsAskBid(data)
      }
    }
  },
  beforeDestroy() {
    if (mqtt.off) mqtt.off('update.quote', this.updateAskBid)
    this.unsubAskBid()
  },
  watch: {
    mqttConnected: {
      immediate: true,
      handler(connected) {
        if (connected) {
          if (mqtt.off) mqtt.off('update.quote', this.updateAskBid)
          if (mqtt.on) mqtt.on('update.quote', this.updateAskBid)
          this.subAskBid()
        } else {
          if (mqtt.off) mqtt.off('update.quote', this.updateAskBid)
        }
      }
    },
    pollingSymbol(newVal, oldVal) {
      oldVal && this.unsubAskBid(oldVal)
      newVal && this.subAskBid(newVal)
    },
    isOPT(val) {
      val ? this.unsubAskBid() : this.subAskBid()
    }
  }
}
